import React, { useState } from "react";
import Footer from "../../components/footer/Footer";

const PerguntasFrequentes = () => {
  const [activeId, setActiveId] = useState(null);

  const toggleAccordion = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  const AccordionItem = ({ id, title, content }) => {
    const isOpen = activeId === id;
    return (
      <div className="itemWrapper">
        <div className="item" onClick={() => toggleAccordion(id)}>
          <div className="iconCircle">✓</div>
          <span className="questionText">{title}</span>
        </div>
        <div className={`content ${isOpen ? "open" : ""}`}>{content}</div>
      </div>
    );
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <style>{`
        .container { padding: 40px; color: #333; margin: -30px auto; display: flex; gap: 50px; }
        .mainContent { flex: 2; }
        .title { font-size: 26px; font-weight: bold; margin-bottom: 30px; }
        .sectionTitle { font-size: 20px; font-weight: bold; margin: 30px 0 15px 0; }
        .itemWrapper { margin-bottom: 10px; overflow: hidden; }
        .item { display: flex; align-items: center; cursor: pointer; padding: 1px 0px; user-select: none; }
        .iconCircle { background-color: #00d1b2; color: white; width: 20px; height: 20px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 12px; font-size: 12px; flex-shrink: 0; }
        .questionText { font-size: 15px; font-weight: 500; color: #444; }
        .content { max-height: 0; opacity: 0; transition: all 0.3s ease-in-out; padding-left: 32px; font-size: 14px; color: #666; line-height: 1.6; }
        .content.open { max-height: 500px; opacity: 1; padding-top: 10px; padding-bottom: 10px; }
        .landing-sidebar { flex: 1; max-width: 300px; }
        .card { box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2); background-color: rgba(255, 255, 255, 0.06); padding: 15px 30px; border-radius: 30px; position: relative; top: 100px; }
        .cardTitle { font-weight: bold; margin-bottom: 15px; }
        .link { display: block; color: #007bff; text-decoration: none; margin-bottom: 12px; cursor: pointer; font-size: 14px; }
        @media (max-width: 935px) { .landing-sidebar { display: none } .container { margin-left: -10px } }
        @media (min-width: 981px) and (max-width: 1199px) { .container { width: 900px } }
        @media (min-width: 1200px) and (max-width: 1439px) { .container { width: 1080px } }
        @media (min-width: 1440px) { .container { width: 1240px } }
      `}</style>

      <div className="container">
        <div className="mainContent">
          <h1 className="title">Perguntas Frequentes</h1>

          <section id="suaConta" style={{ marginLeft: 20 }}>
            <h2 className="sectionTitle">1. Sua Conta</h2>
            <AccordionItem
              id="s1q1"
              title="Como crio minha conta"
              content="É simples, basta seguir o passo a passo onde será solicitado inclusão de sua foto, confirmação do e-mail e número do celular."
            />
            <AccordionItem
              id="s1q2"
              title="Como reporto um problema na minha conta ou com site ou aplicativo?"
              content="Basta nos mandar formulário específico na área de contato que nosso time de plantão imediatamente averiguará possíveis inconsistências no sistema."
            />
          </section>

          <section id="garantia" style={{ marginLeft: 20 }}>
            <h2 className="sectionTitle">2. Garantia</h2>
            <AccordionItem
              id="s2q1"
              title="Sou cliente (demandante) e quais garantias terei de receber o valor da encomenda caso seja extraviada?"
              content="Aqui entra um método simples e seguro para o envio de suas encomendas. Simples, por que você vai atribuir um valor, de forma justa, a sua encomenda que servirá de “Seguro da Encomenda”. Seguro, por que o viajante, para aceitar levar sua encomenda, tem que reservar o valor do “Seguro da Encomenda” que você atribuiu em uma conta temporária na GoinBag e caso a sua encomenda seja extraviada ou roubada o valor reservado para o “Seguro da Encomenda” será transferido para sua conta via PIX em até 2 dias depois do trânsito finalizado."
            />
            <AccordionItem
              id="s2q2"
              title="Posso desistir de enviar uma encomenda mesmo já tendo confirmado o envio com o viajante?"
              content="Sim, entretanto, como a GoinBag não é empresa de logística (não transportamos encomendas), já teríamos cumprido e prestado nosso serviço: Encontrar alguém que tenha espaço na viajem e queira levar sua encomenda até o destino que você deseja onde o viajante já teria reservado um valor no cartão de crédito dele caso sua encomenda seja roubada ou extraviada. Assim, em caso de seu cancelamento, um pequeno valor correspondente a 25% da contribuição pelo serviço anteriormente realizada por você (viajante) será descontado, mas o restante será imediatamente estornado no cartão de crédito ou via transferência PIX a depender da forma utilizada na efetivação."
            />
            <AccordionItem
              id="s2q3"
              title="Sou viajante, posso desistir de levar uma encomenda mesmo já tendo confirmado que a levaria?"
              content="Sim, entretanto, como a GoinBag não é empresa de logística (não transportamos encomendas), já teríamos cumprido e prestado nosso serviço: Encontrar alguém que tenha uma encomenda que você (viajante) possa levar e que está pessoa se disponibilizou em pagar uma contribuição para você levara a encomenda dela. Assim, no caso de seu cancelamento, um pequeno valor correspondente a 25% da “Reserva do Valor de Seguro da Encomenda” anteriormente realizada por você (viajante) será descontado, mas o restante será imediatamente estornado no cartão de crédito ou via transferência PIX a depender da forma utilizada pelo viajante para o pagamento do valor do seguro."
            />
            <AccordionItem
              id="s2q4"
              title="Levei uma encomenda, mas o valor não foi creditado na minha conta e já tem 48 hora"
              content="Nosso processo de transferência de recursos é automático, entretanto, casos de força maior como instabilidade no sistema pode gerar algum atraso. Solicitamos que nos envie detalhes da situação mediante formulário na área de contato que nosso time de plantão irá tempestivamente solucionar sua demanda."
            />
          </section>

          <section id="pagamentos" style={{ marginLeft: 20 }}>
            <h2 className="sectionTitle">3. Pagamentos</h2>
            <AccordionItem
              id="s3q1"
              title="Quais as opções que tenho para pagar pelos serviços de envio das minhas encomendas?"
              content="O pagamento da contribuição ao viajante ou mesmo do valor do seguro da encomenda (pago pelo viajante) pode ser feito mediante cartão de crédito ou por transferência através de PIX."
            />
            <AccordionItem
              id="s3q2"
              title="Meu cartão de crédito não foi aceito, o que posso fazer?"
              content="Neste caso, se for por falta de limite ou problemas na sua bandeira, pode usar outro cartão ou fazer a transferência via PIX."
            />
            <AccordionItem
              id="s3q3"
              title="O cartão de crédito tem que ser em meu nome?"
              content="Não, entretanto, terá que fornecer dados do proprietário do cartão que sempre estarão sujeito a análise do banco e/ou da bandeira do cartão para aprovação."
            />
          </section>

          <section id="informacaoesContato" style={{ marginLeft: 20 }}>
            <h2 className="sectionTitle">4. Informações de contato</h2>
            <AccordionItem
              id="s4q1"
              title="Como faço uma sugestão ou reclamação?"
              content="Basta nos mandar formulário específico na área de contato que nosso time de plantão apreciará com atenção e empatia sua demanda."
            />
          </section>

          <section id="seguranca" style={{ marginLeft: 20 }}>
            <h2 className="sectionTitle">5. Segurança e política de dados</h2>
            <AccordionItem
              id="s5q1"
              title="Como posso confiar no viajante?"
              content="Para levar sua encomenda, o viajante tem que transferir para o sistema da GoinBag o valor do seguro que você vai atribuir a sua encomenda e em casos raros de roubo ou extravio/avarias o valor do seguro que você atribuiu a sua encomenda, vai ser transferido para sua conta. Um método simples, rápido e eficiente que lhe garante receber o valor da sua encomenda nestes casos."
            />
            <AccordionItem
              id="s5q2"
              title="Posso enviar encomendas para o exterior?"
              content="No momento, a GoinBag está aguardando registros já solicitados de patente em diversos países do Mundo e em breve poderá enviar suas encomendas para inúmeros países, mas no momento estamos atuando no Brasil."
            />
            <AccordionItem
              id="s5q3"
              title="Quem é responsável pela minha encomenda?"
              content="Somos um sistema inteligente, seguro, rápido e econômico de encontrar viajantes em todo Brasil que possuem espaços disponíveis e que queiram levar sua encomenda até o lugar que você deseja. Não somos empresa de transporte nem logística. Assim, o único responsável por levar sua encomenda é o viajante."
            />
          </section>
        </div>

        <div className="landing-sidebar">
          <div className="card">
            <h3 className="cardTitle">Atalho</h3>
            <a onClick={() => scrollToSection("suaConta")} className="link">
              Sua Conta
            </a>
            <a onClick={() => scrollToSection("garantia")} className="link">
              Garantia
            </a>
            <a onClick={() => scrollToSection("pagamentos")} className="link">
              Pagamentos
            </a>
            <a
              onClick={() => scrollToSection("informacaoesContato")}
              className="link"
            >
              Informações de contato
            </a>
            <a onClick={() => scrollToSection("seguranca")} className="link">
              Segurança e política de dados
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PerguntasFrequentes;
